export default {
  isLoggedIn() {
    const tokenExits = localStorage.getItem('token');
    if (tokenExits) {
      return true;
    }
    return false;
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/auth/getters.js